import { mapState } from 'vuex';
import DatePeriodPicker from '@/components/common/dateperiodpicker/DatePeriodPicker.vue';

export default {
  name: 'AuditReportGenerator',
  props: {
    clientApiId: String
  },
  data () {
    return {
      loading: false,
      reportSubCodes: [],
      fromDatePeriod: '',
      toDatePeriod: '',
      generateTitlepage: false
    }
  },
  components: {
    DatePeriodPicker
  },
  computed: {
    ...mapState(['config']),
    getTitle () {
      return this.$t('audit.generate-pdf.title');
    },
    reportNameOptions () {
      return this.ZPFormatHelper.getReportNameOptions();
    }
  },
  methods: {
    getReports () {
      this.loading = true;
      const self = this;
      let path = 'audit/generate-audit-pdf/' + this.clientApiId + '/' + this.fromDatePeriod + '/' + this.toDatePeriod + '?generateTitlepage=' + (this.generateTitlepage ? 1 : 0)
      if (this.reportSubCodes.length > 0) {
        path += '&reportSubCodes=' + this.reportSubCodes.join(';');
      }
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_DOWNLOAD, [], function (response) {
        self.$refs['modal-window'].hide();
        self.loading = false;
      });
    },
    close () {
      this.$refs['modal-window'].hide();
    },
    show () {
      this.$refs['modal-window'].show();
    }
  }
}
